<template>
  <div class="">

    <nav :class="{ hide: $route.meta.hideNav }" class="flex justify-between items-center h-14 bg-white">
      <router-link to="/"><img alt="klevaar logo" class="logo" src="@/assets/Klevaar.svg" /></router-link>
      <ul class="hidden lg:flex justify-between items-center space-x-6 nav-item h-full px-4 relative">
        <li class="">
          <div class="dropdown-wrapper">
            <a to="#" class="font-semibold hover:text-brandCol inline-flex cursor-pointer"><span
                class="block mr-1">Products</span> <img src="../../assets/svg/drop-down.svg" alt="DropDown Icon" /></a>
            <div class="dropdown-container">
              <ul class="dropdown-menu">
                <li class="dropdown-item">
                  <router-link to="/search" class="dropdown-link">
                    <h5>ADVANCED SEARCH</h5>
                    <p>Explore verified economic data through interactive charts, trends, and insights for better
                      decision-making.</p>
                  </router-link>
                </li>
                <li class="dropdown-item">
                  <router-link to="#" class="dropdown-link pointer-events-none">
                    <div class="flex gap-2 items-center">
                      <h5>COUNTRY DASHBOARD</h5>
                      <p class="px-2 bg-coming-soon">Coming Soon</p>
                    </div>
                    <p>Access key indicators, analyze trends, and compare country data in one comprehensive dashboard.
                    </p>
                  </router-link>
                </li>
                <li class="dropdown-item">
                  <router-link to="/fact-checking" class="dropdown-link">
                    <h5>FACT CHECKING</h5>
                    <p>Fact-check statements against trusted African data sources to ensure accuracy and credibility.
                    </p>
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </li>
        <li><router-link to="/about-us" class="font-semibold hover:text-brandCol">About Us</router-link></li>
        <li><router-link to="/blog" class="font-semibold hover:text-brandCol">Blog</router-link></li>
        <li><router-link to="/contact-us" class="font-semibold hover:text-brandCol">Contact Us</router-link></li>
      </ul>
      <div class="flex items-center" v-if="!loggedIn">
        <router-link to="/login" class="text-brandCol font-medium">Login</router-link>
        <router-link to="/signup" class="flex items-center justify-end btn-link h-12 border-brandCol rounded-full">
          <span class="text-brandCol font-normal">Sign Up</span>
          <div class="btn-inner bg-brandCol flex items-center justify-center">
            <img src="../../assets/svg/btn-arrow.svg" alt="Button Icon" />
          </div>
        </router-link>
      </div>
      <div class="controls flex items-center" v-if="loggedIn">
        <div class="toggle-button" @click="isOpen = true">
          <!-- Menu -->
          <svg fill="none" height="16" viewBox="0 0 18 16" width="18" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 0H18V2H0V0ZM0 7H18V9H0V7ZM0 14H18V16H0V14Z" fill="black" />
          </svg>
        </div>
        <div class="profile-pic">
          <router-link to="/profile">
            <img alt="" :src="userData.imageUrl || dummyImage" />
          </router-link>
        </div>
      </div>
    </nav>
    <transition name="appear">
      <div v-if="isOpen" class="overlay" @click="close(true)"></div>
    </transition>

    <div ref="navContent" :class="['nav-content', { isOpen: isOpen }]">
      <div class="close" @click="close(true)">
        <img src="@/assets/close.png" alt="" />
      </div>
      <div :class="['profile-info', { notLoggedIn: !loggedIn }]">
        <template v-if="loggedIn">
          <div class="profile-details">
            <img alt="" :src="userData.imageUrl || dummyImage" />
            <h3>{{ userData.fullName }}</h3>
            <p @click="close">
              <router-link to="/profile">Profile Settings</router-link>
            </p>
          </div>
        </template>
        <template v-else>
          <h3>You're not logged in</h3>
          <p>Please sign in to have full access.</p>
        </template>
      </div>
      <div class="nav-list">
        <div v-for="group in menu" :key="group.title" class="menu-group">
          <h3 class="group-title">{{ group.title }}</h3>
          <ul>
            <li v-for="child in group.children" :key="child.title" @click="close()">
              <router-link :to="child.url">
                {{ child.title }}
                <span v-if="child.comingSoon" class="coming-soon">Coming Soon</span>
              </router-link>
            </li>
          </ul>
        </div>

        <!-- sign out     -->
        <div v-if="loggedIn" class="sign-out menu-group">
          <div class="group-title">sign out</div>
          <ul>
            <li class="sign-out" @click="logout">Sign out</li>
          </ul>
        </div>
        <div v-else style="margin-bottom: 15px">
          <k-button class="signin-btn" variant="short" @click="$router.push({ path: '/login' })">
            Sign in
          </k-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from './Navbar';

export default Navbar;
</script>

<style lang="scss" scoped>
nav {
  height: 55px;
  margin-top: 24px;
  margin-bottom: 24px;
  margin-left: 112px;
  margin-right: 112px;

  @media screen and (max-width: 640px) {
    margin-right: 24px;
    margin-left: 24px;
  }
}

.nav-item {
  background-color: #F7F9FC;
  width: 468px;
  border-radius: 40px;
}


.btn-link {
  width: 141.43px;
  height: 44px;
  border-width: 1.57px;

  .btn-inner {
    width: 34.57px;
    height: 34.57px;
    border-radius: 50%;
    margin-right: 5px;
  }
}

.logo {
  width: 113px;
  height: 26px;
}

.profile-pic {
  width: 3.2rem;
  height: 3.2rem;
  border-radius: 50%;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
}

.nav-content {
  width: 35.2rem;
  height: 100vh;
  position: fixed;
  right: -35.2rem;
  top: 0;
  z-index: 15000;
  background: $white;
  transition: right 0.3s ease-out;
  display: grid;
  grid: 16.8rem auto / 1fr;
  //overflow-y: scroll;
  //overflow-x: hidden;

  &.isOpen {
    right: 0;
  }

  .close {
    position: absolute;
    right: 2.4rem;
    top: 2.4rem;
    width: 4.8rem;
    height: 4.8rem;
    box-shadow: 0 0 0.8rem rgba(0, 0, 0, 0.1);
    display: grid;
    place-content: center;
    border-radius: 50%;
    cursor: pointer;

    img {
      width: 1.3rem;
    }

    @media (min-width: 520px) {
      display: none;
    }
  }

  .profile-info {
    display: flex;
    flex-flow: column;
    justify-content: center;
    min-height: 16.8rem;
    padding: 0 4.8rem;
    box-shadow: 0 0.8rem 2.4rem -0.8rem rgba(0, 0, 0, 0.05);

    @media (min-width: 768px) {
      box-shadow: 0 0.8rem 2.4rem -0.8rem rgba(0, 0, 0, 0.025);
    }

    img {
      width: 5.6rem;
      height: 5.6rem;
      border-radius: 50%;
    }

    &.notLoggedIn {
      padding-top: 0.6rem;
    }

    h3 {
      font-size: 14px;
      line-height: 16px;
      margin-bottom: 0.4rem;
    }

    .profile-details {
      display: grid;
      grid: repeat(2, 2.8rem) / 5.6rem auto;
      column-gap: 1.6rem;

      img {
        grid-area: 1/1/3/2;
      }

      h3 {
        align-self: end;
      }

      p {
        align-self: start;
      }

      a {
        font-weight: 600;
        font-size: 12px;
        line-height: 20px;
        letter-spacing: -0.0015em;
        text-decoration-line: underline;
      }
    }
  }

  .nav-list {
    overflow: hidden scroll;
    padding: 4.8rem 4.8rem 0;
  }

  .menu-group {
    margin-bottom: 5.6rem;

    &:last-child {
      margin-bottom: 5.8rem;
    }

    .group-title {
      margin-bottom: 2.4rem;
      font-size: 10px;
      line-height: 12px;
      font-weight: 400;
      text-transform: uppercase;
      letter-spacing: 0.1em;
    }

    ul {
      list-style: none;

      li {
        display: flex;
        height: 3.2rem;
        align-items: center;
        cursor: pointer;
        transform-origin: 0 50%;
        transition: transform 0.075s ease-out, font-weight 0.075s ease-out;
        font-weight: 600;
        font-size: 14px;
        line-height: 16px;

        &:hover {
          transform: scale(1.02);
          font-weight: 700;
        }

        &:active {
          transform: scale(0.975);
          font-weight: 700;
        }

        &:not(:last-child) {
          margin-bottom: 0.8rem;
        }

        a {
          display: flex;
          align-items: center;
          width: 100%;
          height: 100%;
        }
      }

      .sign-out {
        margin-bottom: 2.4rem;
        color: $error;
      }

      .coming-soon {
        margin-left: 1.6rem;
        border-radius: 0.4rem;
        padding: 0.4rem 0.8rem;
        background: $primary-purple;
        color: $white;
        font-weight: 600;
        font-size: 6px;
        line-height: 7px;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        pointer-events: none;
      }
    }
  }
}

.controls {
  display: grid;
  grid: 1fr / auto-flow max-content;
  column-gap: 1.6rem;

  .profile-pic {
    width: 3.2rem;
    height: 3.2rem;
    border-radius: 50%;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }
  }
}

.appear-enter-active,
.appear-leave-active {
  transition: opacity 0.3s ease-out;
}

.appear-enter-to {
  opacity: 1;
}

.appear-enter,
.appear-leave-to {
  opacity: 0;
}

.dropdown-wrapper {
  position: relative;
  display: inline-block;
}

.dropdown-container {
  position: absolute;
  top: 50px;
  left: -30px;
  width: 468px;
  background-color: #FAFAFA;
  border-radius: 16px;
  padding: 16px;
  z-index: 100;
  display: none;
}

/* Create the bridge BETWEEN the link and dropdown */
.dropdown-wrapper::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  height: 50px;
  /* This should match the distance to your dropdown */
  background-color: transparent;
  z-index: 99;
}

.dropdown-item {
  padding: 12px;
  border-radius: 8px;

  .bg-coming-soon {
    font-size: 12px;
    background-color: #6B0B5B;
    border-radius: 20px;
    color: #fff;
  }
}

.dropdown-item h5 {
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0%;
  margin-bottom: 4px;
  color: #181818;
}

.dropdown-item p {
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0%;
  color: #505050;
}

.dropdown-item:hover {
  background-color: #6B0B5B;

  .bg-coming-soon {
    background-color: #2b0324;
  }
}

.dropdown-item:hover h5,
.dropdown-item:hover p {
  color: #fff;
}

/* Show dropdown when hovering over the wrapper */
.dropdown-wrapper:hover .dropdown-container {
  display: block;
}

.overlay {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
  background: rgba(0, 0, 0, 0.1);
}
</style>
